import { Injectable } from '@angular/core';
import { SignalRModule } from 'ng2-signalr';
import { IConnectionOptions, SignalR, SignalRConnection} from 'ng2-signalr';
import { SignalRConfiguration, ConnectionTransport } from 'ng2-signalr';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'
//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';

import { CustomAlert } from '../components/custom-alert.component';

//Models
import { Url } from '../models/url.model';


@Injectable()
export class HubProvider {

    public connection: SignalRConnection;

    constructor(private utilP: UtilProvider, private configP: ConfigProvider, private alert: CustomAlert, private signal: SignalR) {
        this.config('');
    }

    config(hubName: string): SignalRConnection {
        let name = this.utilP.isUndefined(hubName) || this.utilP.isNullOrEmpty(hubName) ? 'congresso' : hubName;
        let url = this.configP.url.Cientifico + '/signalr';
        let options: IConnectionOptions = { hubName: name, url: url, jsonp: true };
        if (this.connection == undefined)
            this.connection = this.signal.createConnection(options);
        return this.connection;
    }

    start(): any {
        var _start = this.connection.start();

        this.connection.errors.subscribe((error: any) => {
            console.log('SignalR error: ' + error);
        });

        return _start;
    }


    errorStart() {
        this.alert.showAlert('Falha de conexão', 'Start: Houve um erro de conexão ao servidor.');
    }


    errorMethod(msg) {

        if (this.utilP.isUndefined(msg) || this.utilP.isNullOrEmpty(msg))
            msg = 'Ocorreu um erro, tente novamente.';

        this.alert.showAlert('Falha de conexão', msg);
    }

}


// WEBPACK FOOTER //
// ./src/providers/hub-provider.ts